import {
    createActionTypeFactory,
    createNamespaceActionCreatorFactory,
    createNamespaceReducerFactory,
    createNamespaceSelectorFactory,
    IActionTypeFactory,
    INamespaceActionCreatorFactory,
    IActionReducerFactory,
    ISelectorFactory,
} from '@omaze/redux';

import { ITooltipState, TOOLTIP_NAMESPACE } from './Tooltip.state';

export const createTooltipActionType: IActionTypeFactory = createActionTypeFactory(TOOLTIP_NAMESPACE);
export const createTooltipActionCreatorFactory: INamespaceActionCreatorFactory = createNamespaceActionCreatorFactory(TOOLTIP_NAMESPACE);
export const createTooltipReducerFactory: IActionReducerFactory<ITooltipState> = createNamespaceReducerFactory<ITooltipState>(TOOLTIP_NAMESPACE);
export const createTooltipSelector: ISelectorFactory<ITooltipState> = createNamespaceSelectorFactory<ITooltipState>(TOOLTIP_NAMESPACE);
